module.exports = __webpack_public_path__ + "static/media/phones-transparent.113bd946.png";